import React from "react"
import { getSigningCertificate } from "@web-eid/web-eid-library/web-eid"
import { useTranslation } from "react-i18next"
import { withFormik, FormikProps, Form } from "formik"
import { Typography } from "@mui/material"

import PollingService from "redux/api/pollingService"
import { Card, Submit } from "components/Sign/elements"
import { ClientIdCardSignPrepareFormValues } from "types"

interface FormProps {
  onSubmit: (values: ClientIdCardSignPrepareFormValues) => void
}

type Props = FormikProps<ClientIdCardSignPrepareFormValues> & FormProps

const IdCardForm = ({ isSubmitting }: Props) => {
  const { t } = useTranslation()

  const isPolling = PollingService.isPolling()

  return (
    <Form>
      <Card elevation={0}>
        <Typography
          dangerouslySetInnerHTML={{ __html: t("features.sign.id_card.text") }}
        />
      </Card>
      <Submit type="submit" disabled={isSubmitting || isPolling}>
        {t("common.sign")}
      </Submit>
    </Form>
  )
}

const IdCardFormWithFormik = withFormik<
  FormProps,
  ClientIdCardSignPrepareFormValues
>({
  enableReinitialize: true,
  handleSubmit: async (_values, { props: { onSubmit } }) => {
    const { certificate, supportedSignatureAlgorithms } =
      await getSigningCertificate({ lang: "en" })

    onSubmit({
      certificate,
      supported_signature_algorithms: supportedSignatureAlgorithms,
    })
  },
})(IdCardForm)

export default IdCardFormWithFormik
